const LOWERCASE = 'abcdefghijklmnopqrstuvwxyz'
const UPPERCASE = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
const NUMBERS = '0123456789'

const generateRandomPassword = ({ length = 10, numbers = false, lowercase = true, uppercase = true } = {}) => {
  const pool = (lowercase ? LOWERCASE : '') + (uppercase ? UPPERCASE : '') + (numbers ? NUMBERS : '')
  if (!Number.isInteger(length) || length < 1) throw new TypeError('Password length must be a positive integer')
  if (!pool) throw new TypeError('At least one password character pool must be enabled')
  if (!globalThis.crypto || typeof globalThis.crypto.getRandomValues !== 'function') throw new Error('A secure browser random-number generator is required')
  const bytes = new Uint8Array(1)
  const limit = 256 - (256 % pool.length)
  return Array.from({ length }, () => {
    do { globalThis.crypto.getRandomValues(bytes) } while (bytes[0] >= limit)
    return pool[bytes[0] % pool.length]
  }).join('')
}

export default generateRandomPassword
